module.exports = __webpack_public_path__ + "media/images/prize__matchday@2x-04aff293914d95e4d4e7299c942ffe6d.jpg";